import React from 'react'

const Nodejs_Coding_Pratice_3 = () => {
  return (
    <div>
      <h1>Coding Pratice 3</h1>
    </div>
  )
}

export default Nodejs_Coding_Pratice_3
